import type { ExpanderListItem } from '@rio-cloud/rio-uikit/ExpanderList';

import {
    getServiceOrderIcon,
    isKnownServiceOrderCategory,
    ServiceTypeName,
} from '#components/shared/ServiceTypeName.tsx';
import type { ServiceOrder } from '#domain/model/ServiceOrder.ts';

export const getServiceOrderExpanderListItem = (
    serviceOrder: ServiceOrder,
    index: number,
    isSelected: boolean,
    setSelectedIndex: (stopId?: number) => void
): ExpanderListItem => ({
    id: serviceOrder.id,
    header: (
        <div>
            <span
                className={`uikit-icon ${getServiceOrderIcon(serviceOrder.category)} text-color-gray text-size-h4 padding-right-10`}
                aria-hidden='true'
            />
            <span>
                <ServiceTypeName category={serviceOrder.category} fallback={serviceOrder.order} />
            </span>
        </div>
    ),
    open: isSelected,
    onOpen: () => setSelectedIndex(index),
    onClose: () => setSelectedIndex(undefined),
    bodyClassName: 'padding-top-0',
    body: (
        <div className='display-flex flex-column gap-5'>
            {isKnownServiceOrderCategory(serviceOrder.category) && <span>{serviceOrder.order}</span>}
            {serviceOrder.company && <span>{serviceOrder.company}</span>}
            {serviceOrder.secondary_reference_id && <span>{serviceOrder.secondary_reference_id}</span>}
            {serviceOrder.note && <span>{serviceOrder.note}</span>}
        </div>
    ),
});
